

























import { Component, Vue } from "vue-property-decorator";

import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Galery from "@/components/Galery.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Galery,
    Header,
    Menu,
    NextPrevBtn,
    Footer
  }
})
export default class CVExample extends Vue {
  protected cvIut: string[] = [
    "/picture_cv/Example_CV_IUT1.jpg",
    "/picture_cv/Example_CV_IUT2.jpg",
    "/picture_cv/Example_CV_IUT3.jpg",
    "/picture_cv/Example_CV_IUT4.jpg",
    "/picture_cv/Example_CV_IUT5.jpg",
    "/picture_cv/Example_CV_IUT6.jpg"
  ];
  protected nxtprevCVExample = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail1.png",
    NextImage: "/thumbnail3.png",
    NextLink: "/CV/CV_Video",
    PrevLink: "/CV/Outils"
  };
}
